// extracted by mini-css-extract-plugin
export default {"tabContent":"e8wBt","tabContentActive":"kFA2N"};